"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MuiButton = {
  defaultProps: {
    fullWidth: true,
    variant: "contained"
  },
  styleOverrides: {
    root: {
      borderRadius: 8,
      fontWeight: 700,
      boxShadow: "none",
      padding: '8px 16px',
      '&:hover': {
        boxShadow: "none"
      }
    }
  }
};
exports.default = {
  MuiButton: MuiButton
};